import {IUserData, IUserPrivateMetadata} from "@buildwithflux/models";

export type SurveyData = {
    fullName: string;
    role: string | undefined;
    company: string | undefined;
    experience: string | undefined;
    hearAboutFlux: string | undefined;

    /**
     * @deprecated We stopped asking this in Dec 2024.
     */
    primaryUse?: string;

    /**
     * @deprecated We stopped asking this in Oct 2025.
     */
    tools?: string;
};

export function getCurrentSurveyData({
    user,
    privateMetadata,
}: {
    user: IUserData | undefined;
    privateMetadata: IUserPrivateMetadata | undefined;
}): SurveyData {
    return {
        fullName: user?.full_name ?? "",
        role: privateMetadata?.personal?.role ?? undefined,
        company: privateMetadata?.personal?.company ?? undefined,
        experience: privateMetadata?.personal?.experience ?? undefined,
        hearAboutFlux: privateMetadata?.personal?.hearAboutFlux ?? undefined,
    };
}

export function surveyDataIsComplete(surveyData: Partial<SurveyData>): boolean {
    return (
        (surveyData.fullName?.length ?? 0) > 0 &&
        surveyData.role !== undefined &&
        surveyData.company !== undefined &&
        surveyData.experience !== undefined &&
        surveyData.hearAboutFlux !== undefined
    );
}
